export const LogoMark = ({ className = "h-8 w-8" }) => (
  <img
    src="/images/icon.png"
    alt="Infra Digest app icon"
    className={`rounded-lg ${className}`}
  />
);

export const PlayStoreIcon = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M5 2.9c0-1 1.1-1.6 2-1.1l13 8.1a1.3 1.3 0 0 1 0 2.2l-13 8.1c-.9.5-2-.1-2-1.1V2.9Z" />
  </svg>
);

export const Diamond = ({ className = "" }) => (
  <span aria-hidden="true" className={`inline-block h-1.5 w-1.5 rotate-45 ${className}`} />
);

export const CornerTicks = ({ className = "text-navy-800/50" }) => {
  const positions = [
    "-top-2.5 -left-2.5",
    "-top-2.5 -right-2.5",
    "-bottom-2.5 -left-2.5",
    "-bottom-2.5 -right-2.5",
  ];
  return (
    <>
      {positions.map((p) => (
        <span key={p} aria-hidden="true" className={`absolute ${p} ${className}`}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M8 1v14M1 8h14" stroke="currentColor" strokeWidth="1.4" />
          </svg>
        </span>
      ))}
    </>
  );
};

export const Logo = ({ light = false, sub = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark light={light} className="h-8 w-8" />
    <span className="leading-none">
      <span className={`block font-display text-lg font-bold tracking-tight ${light ? "text-white" : "text-ink"}`}>
        Infra Digest
      </span>
      {sub && (
        <span className="mt-1.5 block text-micro uppercase text-current opacity-50">
          India Infrastructure Knowledge Hub
        </span>
      )}
    </span>
  </span>
);
